import { useState } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { useMutation, useQuery } from "@tanstack/react-query";

import { SaveButton } from "ui-components/Form";
import { Layout } from "ui-components/Layout";
import { Success, Error } from "ui-components/Alert";
import { formRender, initialValues, adjustmentReasonValidation } from "./adjustment-reason-schema";
import { getAdjustmentReason, editAdjustmentReason } from "services/data.internal.service";
import AdjustmentReasonInfo from "./components/AdjustmentReasonInfo";
import { useLocation } from "react-router-dom";

function EditAdjustmentReason() {
  const location = useLocation();
  const { reasonCode } = location.state;
  const [alert, setAlert] = useState(null);
  const [formValues, setFormValues] = useState(null)
  const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);

  useQuery({
    queryKey: ["adjustment-reason", { reasonCode }],
    queryFn: () => getAdjustmentReason({ reasonCode }),
    onSuccess: (data) => setFormValues(data.data.data),
    onError,
  });

  const editAdjustmentReasonMutation = useMutation(editAdjustmentReason, {
    onSuccess: (data) => {
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });
  const form = useForm({
    defaultValues: initialValues,
    values:formValues,
    resolver: yupResolver(adjustmentReasonValidation),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isDirty, isSubmitting },
    setValue,
    reset,
  } = form;

  const infoProps = {
    mode: "EDIT",
    control,
    errors,
    setValue,
    formRender,
  };
  const onSubmit = (data) => {
    editAdjustmentReasonMutation.mutate(data, {
      onSuccess: () => {
      },
    });
  };
  const editStatus = editAdjustmentReasonMutation.status === "loading";
  return (
    <Layout>
      {alert}
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <AdjustmentReasonInfo {...infoProps} />
        <SaveButton label="Save" disabled={!isDirty && editStatus} url="/setup/adjustment-reason" />
      </form>
    </Layout>
  );
}

export default EditAdjustmentReason;
